import { OrderedList } from '../OrderedList';
import { Table } from '../Table';

interface TableData {
  value: string;
  colspan?: number;
  align?: 'left' | 'center' | 'right' | 'justify' | 'char';
}

interface TableInterface {
  headers: Array<TableData>;
  rows: Array<{
    data: Array<TableData>;
  }>;
}

export interface IfscContentInterface {
  id: string;
  header: string;
  para1?: Array<string>;
  list?: Array<string>;
  table?: TableInterface;
  para2?: Array<string>;
  image?: string;
}

export const ContentComponent = ({
  id,
  header,
  para1,
  list,
  table,
  para2,
  image,
}: IfscContentInterface): JSX.Element => {
  return (
    <div className="py-6">
      <span className="anchor" id={id}></span>
      <h2 className="text-s-40 sm:text-s-20">{header}</h2>
      {para1 &&
        para1.map((para) => (
          <p className="my-4" key={para}>
            {para}
          </p>
        ))}
      {list && <OrderedList list={list} />}
      {table && <Table headers={table.headers} rows={table.rows} />}
      {para2 &&
        para2.map((para: string) => (
          <p className="my-4" key={para}>
            {para}
          </p>
        ))}
      {image && (
        <img
          src={image}
          className="my-4"
          width="80%"
          height="auto"
          alt="img"
          loading="lazy"
        />
      )}
    </div>
  );
};
